import { registerPlugin } from '@capacitor/core';
const BottomSheet = registerPlugin('BottomSheet', {
    web: () => import('./web').then(m => new m.BottomSheetWeb()),
});
export * from './definitions';
export { BottomSheet };
//# sourceMappingURL=index.js.map